import { matchesAirror, NO_PERMISSION, NO_WORKSPACE_PERMISSION, NOT_FOUND } from '@air/errors';

/**
 * A missing or hidden comment is ordinary history. Anything else is a blip worth one retry.
 * `Discussions.Comments.get` returns not-found when the caller cannot see the discussion.
 */
export const isCommentUnresolvableError = (error: unknown): boolean =>
  matchesAirror(error, NOT_FOUND) ||
  matchesAirror(error, NO_PERMISSION) ||
  matchesAirror(error, NO_WORKSPACE_PERMISSION);
